var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgİconLanguagePinkTr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.677,4.441h-1.162v1.916h1.138c.37,0,.647-.078.829-.235s.274-.389.274-.696c0-.302-.091-.541-.274-.718s-.451-.266-.806-.266h0Z",
    fill: "#da45f4",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.399.794H1.6c-.883,0-1.6.715-1.6,1.6v8.809c0,.885.717,1.6,1.6,1.6h3.982l1.974,2.958c.049.074.116.134.193.176.077.041.163.062.251.062s.174-.022.253-.062c.077-.042.142-.102.191-.176l1.977-2.958h3.98c.885,0,1.6-.715,1.6-1.6V2.394c0-.885-.715-1.6-1.6-1.6h-.002ZM7.46,4.441h-1.862v5.563h-1.319v-5.563h-1.853v-1.017h5.034v1.017h0ZM13.447,10.004h-1.36c-.121-.096-.199-.258-.235-.483s-.054-.44-.054-.642v-.466c0-.328-.09-.584-.269-.766s-.431-.274-.757-.274h-1.256v2.63h-1.319V3.425h2.481c.75,0,1.337.171,1.76.513.423.342.635.818.635,1.43,0,.341-.089.633-.266.877-.178.244-.438.442-.782.592.389.114.668.306.838.574s.255.599.255.994v.483c0,.184.025.376.074.576s.135.349.255.445v.095h0Z",
    fill: "#da45f4",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgİconLanguagePinkTr);
export default __webpack_public_path__ + "static/media/icon_language-pink_tr.0bf9a00c73c5409dc0b18e92b416e0de.svg";
export { ForwardRef as ReactComponent };